import { Component, OnInit, Input } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';

@Component({
  selector: 'app-style-box',
  templateUrl: './style-box.component.html',
  styleUrls: ['./style-box.component.scss']
})
export class StyleBoxComponent implements OnInit {

  @Input() catNames: string[];
  @Input() catFields: string[];
  @Input() series: any[];
  @Input() xlabel: string;
  @Input() ylabel: string;
  @Input() zoomType: Highcharts.OptionsZoomTypeValue;

  @Input() opposite: boolean;
  @Input() percent: boolean;
  @Input() width: string = '100%';
  @Input() height: string = '300px';

  @Input() showLegend: boolean = true;
  showGraph: boolean = true;

  chart: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options;
  chartXLabel: string;

  labelToColor: any = {
    original: 'rgba(227,143,72,0.75)',
    investable: 'rgba(129,186,241,0.75)',
    protected: 'rgba(94,187,75,1)',

    default1: 'rgba(40,106,172,0.75)',
    default2: 'rgba(145,187,225,0.75)',
    default3: 'rgba(180,209,236,0.75)',
  };
  labelToName: any = {
    original: 'Original',
    investable: 'Investable',
    protected: 'Protected',

    default1: 'Min Variance',
    default2: 'Risk Parity',
    default3: 'Equal Weights',
  };

  seriesLabelToName: any = {...this.labelToName};

  constructor() { }

  ngOnInit(): void {
    this.percent = this.percent!=undefined;

    this.series.forEach((data) => {
      if (('label' in data) && ('name' in data)) {
        this.seriesLabelToName[data['label']] = data['name'];
      }
    });

    // If categories are not specified, data object keys are used.
    // All the series.values must have the same keys.
    if (!this.catNames && this.catFields) {
      this.catNames = this.catFields;
    } else if (this.catNames && !this.catFields) {
      this.catFields = this.catNames;
    } else if (!this.catNames && !this.catFields) {
      this.series.forEach(
        (data) => {
          if (data && data.values) {
            this.catNames = Object.keys(data.values);
            this.catFields = this.catNames;
          }
        }
      )
    }

    let thisComponent = this;
    this.chartOptions = {
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: true
      },
      navigation: {
        buttonOptions: {
          verticalAlign: 'bottom'
        }
      },
      chart: {
          type: 'bar',
          zoomType: this.zoomType,
          backgroundColor: 'rgba(255,255,255,0)'
      },
      xAxis: {
          title: {
              text: this.xlabel
          },
          categories: this.catNames,
          opposite: (this.opposite!=undefined),
          labels: {
              style: {
                color: 'grey'
              }
          }
      },
      yAxis: {
        min: -2.5, max: 2.5,
        title: {
            text: this.ylabel
        },
        gridLineColor: 'rgba(100,100,100,1)',
        labels: {enabled: false},
        plotBands: [{
            from: -2.5, to: -1.03,
            color: "#ffffff10",
            borderWidth: 10, borderColor: "#ffffff00",
            label: {
              style: {color: 'grey', fontWeight: 'bold'},
              y: 0,
              text: 'Lower',
              align: 'center'
          }},{
            from: -0.97, to: 0.97,
            color: "#ffffff20",
            borderWidth: 10, borderColor: "#ffffff00",
            label: {
              style: {color: 'grey', fontWeight: 'bold'},
              y: 0,
              text: 'Neutral',
              align: 'center'
          }},{
            from: 1.03, to: 2.5,
            color: "#ffffff10",
            borderWidth: 10, borderColor: "#ffffff00",
            label: {
              style: {color: 'grey', fontWeight: 'bold'},
              y: 0,
              text: 'Upper',
              align: 'center'
          }
        }]
      },
      tooltip: {
        formatter: function () {
          const selectedSeries = thisComponent.series.filter((series) =>{
            return this.series.name == thisComponent.seriesLabelToName[series.label];
          })[0];
          const selectedCatLabel = thisComponent.catNames.map((e:string, i:number) => {
            return [e, thisComponent.catFields[i]]; // Zip arrays
          }).filter((e) => {
            return e[0]==this.point.category;
          })[0][1];
          const selectedData = selectedSeries.values[selectedCatLabel];
          return '<b>' + this.series.name + '</b><br>' +
                  this.point.category + ': rank ' + selectedData.rank + '/' + selectedData.nb_analysis;
        },
        useHTML: true
      },
      plotOptions: {
        series: {
            marker: {
                enabled: false
            },
          borderWidth: 0.5,
          borderColor: 'grey'
        }
      },

      // Define the data points. All series have a dummy year
      // of 1970/71 in order to be compared on the same x axis. Note
      // that in JavaScript, months start at 0 for January, 1 for February etc.
      series: this.series.filter(series=>series.values).map(
        (data) => {
          return {
            name: data.name ? data.name : this.seriesLabelToName[data.label],
            data: this.catFields.map(
              (catField) => {
                return 5*(data.values[catField].rank/data.values[catField].nb_analysis)-2.5;
              }
            ),
            color: this.labelToColor[data.label],
            type: undefined,
          }
        }
      ),

      responsive: {
          rules: [{
              condition: {
                  maxWidth: 500
              },
              chartOptions: {
                  plotOptions: {
                      series: {
                          marker: {
                              radius: 2.5
                          }
                      }
                  }
              }
          }]
      },
      legend: {
        enabled: this.showLegend,
        itemStyle: {
          color:'grey'
        }
      }
    };

    HC_exporting(Highcharts);

  }

}
